import { UnsupportedBrowser } from '@nesso/ui/blocks/unsupported-browser';

import { appConfig } from '@/shared/config/app-config';

export function UnsupportedBrowserPage() {
    return (
        <div className="flex flex-1 flex-col items-center px-4">
            <UnsupportedBrowser urlToCopy={appConfig.marketingSiteUrl} />
        </div>
    );
}
